module.exports = __webpack_public_path__ + "static/media/side.64487f45.jpg";